export default __webpack_public_path__ + "static/rishav-6c9200bef8fa2c9e264466505caa361e.jpeg";